<template>
    <div class="run" v-loading.fullscreen="loading">
		<div class="user">
			<div class="u_header">
				<span>用户管理</span>
				<div style="display:flex; align-items:center;">
					<div style="display:flex;align-items:center;">
						<input type="checkbox" id="box" @change='search' :checked="params.show_disabled">
						<!-- v-model="params.show_disabled" -->
						<label for="box" class="checkbox">显示禁用</label>
					</div>
					<el-button plain type="primary" @click="addUser">新增用户</el-button>
					<el-button plain type="success" @click="freshen">刷新</el-button>
				</div>
			</div>
			<div class="u_table">
                <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                    <el-table-column label="操作" align="center" width='80'>
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="edit"  title="修改" @click="modifyUser(scope.row)"></i>
                                <i class="delete"  title="删除" @click="deleteUser(scope.row)"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="online" label="在线状态" align="center">
                        <template slot-scope="scope">
                            <span :style="scope.row.online==1?'color:green;font-size:12px;':'color:#999;font-size:12px;'">{{scope.row.online==1?'在线':scope.row.online==0?'离线':''}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="姓名" align="center"></el-table-column>
                    <el-table-column prop="username" label="登录账号" align="center"></el-table-column>
                    <el-table-column prop="mobile" label="电话" align="center"></el-table-column>
                    <el-table-column prop="combination" label="部门" align="center"></el-table-column>
                    <el-table-column prop="occupation" label="职位" align="center"></el-table-column>
                    <el-table-column prop="status_name" label="功能授权" align="center">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="auth" @click="authorityEdit('admin',scope.row.id)"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status_name" label="仓库权限" align="center">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="auth" @click="authorityWarehouse(scope.row)"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="all_customer" label="客户权限" align="center">
                        <template slot-scope="scope">
                            <button class="btn usable" @click="customerRights(scope.row)" :class="scope.row.all_customer==0?'usable_n':'usable_y'">{{scope.row.all_customer ==0?'已禁用':'已启用'}}</button>
                        </template>
                    </el-table-column>
                     <el-table-column prop="all_fee" label="费用权限" align="center">
                        <template slot-scope="scope">
                            <button class="btn usable" @click="feePermission(scope.row)" :class="scope.row.all_fee==0?'usable_n':'usable_y'">{{scope.row.all_fee==0?'已禁用':'已启用'}}</button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="all_sheet" label="单据权限" align="center">
                        <template slot-scope="scope">
                            <button class="btn usable" @click="documentPermission(scope.row)" :class="scope.row.all_sheet==0?'usable_n':'usable_y'">{{scope.row.all_sheet==0?'已禁用':'已启用'}}</button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" align="center">
                        <template slot-scope="scope">
                            <button class="btn usable" @click="changeStatus(scope.row)" :class="scope.row.status==0?'usable_n':'usable_y'">{{scope.row.status==0?'已禁用':'已启用'}}</button>
                        </template>
                    </el-table-column>
                </el-table>
				<div class="text-center cont_foot">
					<!-- <el-pagination layout="prev, pager, next" :current-page.sync="params.page" :page-count="last_page"></el-pagination> -->
					<pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
				</div>
			</div>
		</div>
		<div class="role">
			<div class="r_header u_header">
				<span>角色管理</span>
				<div>
					<!-- <button class="r_new_btn btn">新增角色</button> -->
					<el-button plain  @click="addRole" type="primary">新增角色</el-button>
				</div>
			</div>
			<div class="r_table">
				<el-table :data="roleList" style="width: 100%;" border height="100%" size="mini" header-cell-class-name="list_table_th">
					<el-table-column label="操作" align="center" width='80'>
						<template slot-scope="scope">
							<div class="icon_wrap">
								<i class="edit"  title="修改" @click="modifyRole(scope.row)"></i>
								<i class="delete"  title="删除" @click="deleteRole(scope.row)"></i>
							</div>

						</template>
					</el-table-column>
					<el-table-column prop="name" label="角色" align="center"></el-table-column>
					<el-table-column prop="status" label="权限" align="center">
						<template slot-scope="scope">
							<div class="icon_wrap">
								<i class="auth" @click="authorityEdit('role',scope.row.id)"></i>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
        <!-- 新增用户 START -->
        <el-dialog v-dialog-drag :title="text" :visible.sync="userDialogVisible" class="eldialog eldialogA eldialogLabelShort" :model="false" width='550px'>
            <div>
                <el-form :model="userForm" :rules="rules" ref="ruleForm">
                    <div class="eldialogFormBox">
                        <el-form-item label="姓名: " prop="name" >
                            <el-input v-model="userForm.name" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="账号: " prop="username">
                            <el-input v-model="userForm.username" :disabled="isAccount" placeholder="请输入账号"></el-input>
                        </el-form-item>
                        <el-form-item label="密码: " prop="password">
                            <el-input  v-if="isNewOrModifyUser"  type='password' v-model="userForm.password" placeholder="请输入密码"></el-input>
                            <el-input v-if="!isNewOrModifyUser"  type='password' v-model="userForm.password" placeholder="请输入新密码"></el-input>
                            <!-- <button v-if="!isNewOrModifyUser" class="mar-l-30 code" v-on:click.stop.prevent="initialize">初始化密码</button> -->
                        </el-form-item>
                        <el-form-item label="职位: " prop="">
                            <el-input v-model="userForm.occupation" placeholder="请输入职位"></el-input>
                        </el-form-item>
                        <el-form-item label="电话: " prop="mobile">
                            <el-input v-model="userForm.mobile" placeholder="请输入电话号码"></el-input>
                        </el-form-item>
                        <el-form-item label="部门: " prop="">
                            <el-input v-model="userForm.combination" placeholder="请输入部门"></el-input>
                        </el-form-item>
                    </div>
                    <!-- <el-row class="row_flex">
                    </el-row>
                    <el-row class="row_flex">
                    </el-row>
                    <el-row class="row_flex">
                    </el-row> -->
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="submitUser('ruleForm')">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="userDialogVisible = false,cancelEdit('ruleForm')">取消</el-button>
            </div>
        </el-dialog>
        <!-- 新增用户 END -->
        <!-- 新增角色 START -->
        <el-dialog v-dialog-drag :title="roleText" :visible.sync="roleDialogVisible" class="eldialog eldialogOneLabel" :model="false" width='25%'>
            <el-form :model="roleForm">
                <el-form-item label="角色名称: " prop="name" >
                    <el-input v-model="roleForm.name" placeholder="请输入名称"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="submitRole">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="roleDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- <el-dialog v-dialog-drag title="仓库权限" :visible.sync="setWarehouseDialog" class="eldialog" :model="false" width='500px'>
            <div class="warehouseSelectBox clearfix">
                <div class="warehouseSelect" v-show="setWarehouseName.length>0" v-for="item in setWarehouseName" :key="item.id">{{item.name}}</div>
                <div class="warehouseTip" v-show="setWarehouseName.length<=0">请在下方选择仓库</div>
            </div>
            <div class="warehouseBox">
                <div v-for="item in setWarehouse" :key="item.id" :class="['warehouse',item.select?'warehouseC':'']" @click="selectWarehouse(item.id)">{{item.name}}</div>
            </div>
            <div class="dialogBtnList clearfix" style="margin-top:10px;">
                <el-button  class="publicBtn dialogBtn" @click="confirmWarehouse">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="setWarehouseDialog = false">取消</el-button>
            </div>
        </el-dialog> -->
        <!-- <el-dialog v-dialog-drag title="仓库权限" :visible.sync="setWarehouseDialog" width="eldialogFilter" class="eldialog eldialogFilter" :model="false">
            
        </el-dialog> -->
        <el-dialog v-dialog-drag :visible.sync="setWarehouseDialog"  class="eldialog eldialogFilter" width="400px" :modal="false" custom-class="full_dialog">
            <div slot="title" class="offerTitle">
                <span style="margin-right: 5px;">仓库权限</span>
                <div class="upimgBtnBox">
                    <el-tooltip class="itema" effect="dark" placement="bottom">
                                <div slot="content">
                                    <span>注:</span><br/>
                                    <span>1.仓库是否启用:开启后该用户可以查看并操作这个仓库货物，关闭反之。</span><br/>
                                    <span>2.仓库是否可售:开启后该用户可以销售此仓库的货物，关闭反之。</span><br/>
                                </div>
                                <div class="tipImg" :label="0"  border></div>
                    </el-tooltip>
                </div>
            </div>
            <div class="printSetBox clearfix">
                <el-table :data="setWarehouse" border stripe highlight-current-row size="mini" height="100%">
                    <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
                    <el-table-column prop="name" label="列表名称"></el-table-column>
                    <el-table-column width="90px" label="是否启用">
                        <template slot-scope="scope">
                            <!-- <div :class="scope.row.show?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row,scope.row.show)"> -->
                            <!-- </div> -->
                            <el-switch 
                                v-model="scope.row.select"
                                active-color="#B21111"
                                :active-value="true"
                                inactive-color="#ccc"
                                :inactive-value="false"
                                @change="changeWarehouseStatus(scope.row.id,$event)">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column width="90px" label="是否可售">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.sales_select"
                                active-color="#B21111"
                                :disabled="scope.row.select==false?true:false"
                                :active-value="true"
                                inactive-color="#ccc"
                                :inactive-value="false"
                                @change="changeWarehouseSales_select(scope.row.id,$event)">
                            </el-switch>
                        </template>
                    </el-table-column>
                
                </el-table>
                <div class="filterBtnList clearfix">
                    <div class="warehouseAllBox clearfix">
                        <div class="warehouseAllName">全部开通</div>
                        <el-switch
                                class="warehouseAllSwitch"
                                v-model="warehouseAllFlag"
                                active-color="#B21111"
                                :active-value="true"
                                inactive-color="#ccc"
                                :inactive-value="false"
                                @change="changeWarehouseAllStatus($event)">
                            </el-switch>
                    </div>
                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="confirmWarehouse">确定</el-button>
                </div>
            </div>
        </el-dialog>
	</div>
</template>
<style scoped>
.warehouseAllBox{float: left;padding-top:8px;}
.warehouseAllName{font-size: 14px;float: left;margin-right:10px;}
.warehouseAllSwitch{float: left;}
.warehouseBox{text-align: left;}
.warehouse{display: inline-block; min-width: 85px;height: 36px;line-height: 32px;text-align: center;padding: 0 12px;border-radius: 3px;border: 1px solid #666666;cursor: pointer;margin: 6px;}
.warehouseC:after{display: block;content: "";width: 21px;height: 21px;position: absolute;right: 0;bottom: 0;background: url(/icon/checkeded.png) no-repeat;background-size: cover;}
.warehouseC{border: 1px solid #b21111;position: relative;color: #B21111;}
.warehouseSelectBox{border-radius: 5px;border:1px solid #ccc;padding:10px;width:100%;box-sizing: border-box;margin-bottom:10px;}
.warehouseSelect{float: left;margin-right:10px;font-size:14px;color:#777;}
.warehouseTip{font-size:14px;color:#777;}
.run{height: 100%; width: 100%; background: #eee; display: flex;padding: 10px 0 0 10px; box-sizing: border-box;overflow: hidden;}
.run .user{width: 80%;margin-right: 8px;background: #fff; display: flex; flex-direction: column;height:100%;overflow: hidden;}
.run .role{width: 20%;background: #fff; display: flex;flex-direction: column;}
/* .run .icon_wrap{padding-top: 5px;} */
/* user start */
.run .u_header{height: 80px;line-height: 80px;width: 100%;display: flex;justify-content: space-between;padding: 0 10px;}
.run .btn{color: #fff;font-size: 14px;border: 0;outline: none;border-radius: 6px;margin-left: 20px;cursor: pointer;}
.run  span{color: #333; font-weight: bold; font-size: 18px;}
.run .usable{width: 60px; font-size: 10px; padding: 5px 0;cursor: pointer;margin-left: 0px;}
.run .usable_n{background: #EEE; color: #B21111;}
.run .usable_y{background: #F9A602; color: #fff;}

.run .user .u_header input{vertical-align:middle;cursor: pointer;}
.run .user .u_header .checkbox{color: #B21111;font-size: 10px; margin-right: 20px;}
/* .run .user .u_header .new_btn{width: 90px;height: 30px;background: #B21111;}
.run .user .u_header .refresh_btn{width: 70px;height: 30px;background: #ccc;} */
.run .user .u_table{height: 100%; padding: 0 10px 50px;flex:1;height: 100%;overflow: hidden;}
.run .auth{background:url('../../assets/backstage_list_shield_noemal@2x.png') no-repeat;background-size: cover;display: inline-block;width: 18px;height: 18px;cursor: pointer;}
.run .edit{background:url('../../assets/backstage_list_pen_noemal@2x.png') no-repeat;background-size: cover;display: inline-block;width: 15px;height: 15px;cursor: pointer;margin-right: 10px;}
.run .delete{background:url('../../assets/backstage_list_delete_noemal@2x.png') no-repeat;background-size: cover;display: inline-block;width: 15px;height: 15px;cursor: pointer;}
.run .auth:hover{background:url('../../assets/backstage_list_shield_suspension@2x.png') no-repeat;background-size: cover;}
.run .edit:hover{background:url('../../assets/backstage_list_pen_suspension@2x.png') no-repeat;background-size: cover;}
.run .delete:hover{background:url('../../assets/backstage_list_delete_suspension@2x.png') no-repeat;background-size: cover;}

.item{width: 50%;}
.row_flex{display: flex;}
.code{font-size: 12px; border:none;border-bottom: 1px solid #ccc;background: #fff;cursor: pointer;outline: 0;}
.input{width: 80%;}
/* user end */
/* role start */
.run .role .r_new_btn{width: 90px;height: 30px;background: #B21111;}
.run .role .r_table{height: 100%; padding: 0 10px 50px;}

div.cell{display: flex; justify-content: center;align-self: center;}
input[type="checkbox"] {width: 12px;height: 12px;display: inline-block;text-align: center;vertical-align: middle;line-height: 12px;position: relative;border-radius: 2px;background: #ccc; margin-right: 5px;}
input[type="checkbox"]::before {content: "";position: absolute;top: 0;left: 0;background: #ccc;width: 100%;height: 100%; border: 1px solid #d9d9d9;border-radius: 2px;}
input[type="checkbox"]:checked::before {content: "\2713";background-color: #333;position: absolute;top: 0;left: 0;width: 100%;border: 1px solid #333;color: #fff;font-size: 14px;font-weight: 500;}
/* role end */
.offerTitle{display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-pack: center;-ms-flex-pack: center;justify-content: center;-webkit-box-align: center;-ms-flex-align: center;align-items: center;}
.upimgBtnBox .tipImg {width: 23px;height: 23px;}
</style>

<script>
import pagination from '../../components/pagination';
export default {
    components:{
        pagination
    },
    data() {
        return {
            /******/
            isOk: true,
            list: [],
            roleList: [],
            userDialogVisible: false,
            roleDialogVisible: false,
            userForm:{name: '',username: '',password: '',mobile: '',combination: '',occupation: ''},
            rules:{
                name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
                username: [{ required: true, message: "请填写账号", trigger: "blur" }],
                mobile: [{ required: true, message: "请填写手机号码", trigger: "blur" }]
            },
            areas:[{id: 1,name: '苏南'},{id: 2,name: '苏北'}],
            text:'',
            roleText:'',
            isNewOrModifyUser:true,
            isNewOrModifyRole:true,
            userID: '',
            roleID: '',
            roleForm: {name: ''},

            current_page : 1,
            last_page: 1,
            total : 0,
            params : {
                show_disabled : true,
                per_page: 20,
            },
            /******/
            loading : false,
            isAccount:true,
            setWarehouse:[],
            setWarehouseName:[],
            setWarehouseDialog:false,
            warehouseConfirm:{
                id:"",
                warehouse_ids:[],
                sales_warehouse_ids:[]
            },
            warehouseAllFlag:false,
        }
    },
    computed: {},
    created() {
        let show_disabled = localStorage.getItem('dw_setting_user_run_show_disabled');
        if (show_disabled) {
            this.params.show_disabled = show_disabled == "true";
        }
        this.getList();
        // this.getCombinationList();
        this.getRoleList();
    },
    mounted() {},
    methods: {
        changeWarehouseStatus(id,e){
            this.setWarehouse.forEach(item=>{
                if(item.id == id){
                    item.select = e
                    item.sales_select = e?item.sales_select:e;
                }
            })
        },
        changeWarehouseSales_select(id,e){
            this.setWarehouse.forEach(item=>{
                if(item.id == id){
                    item.sales_select = e
                }
            })
        },
        changeWarehouseAllStatus(e){
            this.setWarehouse.forEach(item=>{
                item.select = e;
                item.sales_select = e;
            })
        },
        //仓库权限
        authorityWarehouse(row){
            let length = row.warehouse_ids.length <= 0 ? true:false;
            let flag = true;
            this.setWarehouse = row.warehouse;
            this.setWarehouse.forEach(item=>{
                if(length){
                    item.select = true;
                    item.sales_select=true
                }else{
                    if(item.select){
                        this.setWarehouseName.push(item)
                    }else{
                        // item.sales_select = false;
                        flag = false;
                    }
                }
            })
            this.warehouseAllFlag = length ? true:flag;
            this.warehouseConfirm.id = row.id;
            this.setWarehouseDialog = true;
        },
        selectWarehouse(id){
            this.setWarehouseName = [];
            this.setWarehouse.forEach(item=>{
                if(item.id == id){
                    item.select = !item.select;
                }
                if(item.select){
                    this.setWarehouseName.push(item)
                }
            })
        },
        confirmWarehouse(){
            this.setWarehouse.forEach(item=>{
                if(item.select){
                    this.warehouseConfirm.warehouse_ids.push(item.id)
                }
                if(item.sales_select){
                    this.warehouseConfirm.sales_warehouse_ids.push(item.id)
                }
            })
            this.postFunc("/erp/user.warehouse",this.warehouseConfirm,()=>{
                this.tip("操作成功","success")
                this.setWarehouseDialog = false;
                this.getList()
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        //获取用户列表
        getList(){
            this.params.show_disabled = Number(this.params.show_disabled)
            this.postFunc("/erp/user.list",this.params,response=>{
                this.list = response.data.data.data;
                // this.last_page = parseInt(response.data.data.last_page);
                // this.params.page = parseInt(response.data.data.current_page);
                this.last_page = response.data.data.last_page;
                this.total = response.data.data.total;
                this.$refs.pagination.flag = true;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        //获取角色列表
        getRoleList(){
            const self = this;
            return new Promise((resolve, reject) => {
                this.postFunc("/erp/role.list",{},response=>{
                    if(response.data.code == 0){
                        // self.role_list = response.data.data;
                        self.roleList = response.data.data;
                        resolve();
                    } else {
                        reject();
                    }
                })
            }).catch((e) => {});

        },
        //改变状态
        changeStatus(row){
            // row.status = row.status == 1 ? 0:1;
            var status_ = ''
            if(row.status===0){
                row.status=1;
                status_ = 1;
            }else{
                row.status=0;
                status_ = 0;
            }
            this.postFunc("/erp/user.status",{id:row.id,status:status_},response=>{
                if(response.data.code==0){
                    this.getList();
                }
            },error=>{
                    this.tip(error.data.message,"warning")
            })
        },
        //显示禁用
        search(){
            this.params.show_disabled = !this.params.show_disabled;
            localStorage.setItem('dw_setting_user_run_show_disabled',this.params.show_disabled);
            this.getList()
        },
        //客户权限
        customerRights(row){
            var is_grant_ = '';
            if(row.all_customer==0){
                is_grant_ = 1;
                this.$confirm('开启后，该用户能查看所有的客户，确认开启?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/user.grant",{id:row.id,grant_type:'ALL_CUSTOMER',is_grant:is_grant_},response=>{
                        if(response.data.code==0){
                            this.getList();
                            row.all_customer=1;
                        }
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(() => {});
            }else{
                is_grant_ = 0;
                this.$confirm('关闭后，该用户仅能查看自己的客户，确认关闭?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/user.grant",{id:row.id,grant_type:'ALL_CUSTOMER',is_grant:is_grant_},response=>{
                        if(response.data.code==0){
                            this.getList();
                            row.all_customer=0;
                        }
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(() => {});
            }
        },
        //单据权限 (单据和客户权限可写在一个方法里)
        documentPermission(row){
            var is_grant_ = '';
            if(row.all_sheet==0){
                is_grant_ = 1;
                this.$confirm('开启后，该用户能查看所有的单据，确认开启?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/user.grant",{id:row.id,grant_type:'ALL_SHEET',is_grant:is_grant_},response=>{
                        if(response.data.code==0){
                            this.getList();
                            row.all_sheet=1;
                        }
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(() => {});

            }else{
                is_grant_ = 0;
                this.$confirm('关闭后，该用户仅能查看自己的单据，确认关闭?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/user.grant",{id:row.id,grant_type:'ALL_SHEET',is_grant:is_grant_},response=>{
                        if(response.data.code==0){
                            this.getList();
                            row.all_sheet=0;
                        }
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(() => {});
            }
        },
        //费用权限
        feePermission(row){
            var is_grant_ = '';
            if(row.all_fee==0){
                is_grant_ = 1;
                this.$confirm('开启后，该用户能查看所有的费用，确认开启?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/user.grant",{id:row.id, grant_type:'ALL_FEE', is_grant:is_grant_},response=>{
                        if(response.data.code==0){
                            this.getList();
                            row.all_fee=1;
                        }
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(() => {});

            }else{
                is_grant_ = 0;
                this.$confirm('关闭后，该用户仅能查看自己的费用，确认关闭?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/user.grant", {id:row.id,grant_type:'ALL_FEE',is_grant:is_grant_}, response=>{
                        if(response.data.code==0){
                            this.getList();
                            row.all_fee=0;
                        }
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(() => {});
            }
        },
        //删除用户
        deleteUser(row){
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postFunc("/erp/user.delete",{id:row.id},()=>{
                    this.getList();
                    this.tip('删除成功','success');
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(() => {
            });


        },
        //修改用户信息
        modifyUser(row){
            this.userDialogVisible = true;
            this.isNewOrModifyUser = false;
            this.isAccount = true;
            this.text = '修改';
            this.userForm = JSON.parse(JSON.stringify(row));
            // this.userForm.password = '';
            this.userID = row.id;
        },
        //刷新
        freshen(){
            this.getList();
            this.getRoleList();
            this.$message({
                message: '刷新成功',
                type: 'success'
            });
        },
        //新增用户弹窗
        addUser(){
            this.userDialogVisible = true;
            this.isNewOrModifyUser = true;
            this.isAccount = false;
            this.text = '新增用户';
            this.userForm = {name: '',username: '',password: '',mobile: '',combination: '',occupation: ''}
        },
        //新增用户&修改确定
        submitUser(ruleForm){
            if(this.isNewOrModifyUser){
                this.$refs[ruleForm].validate((valid) => {
                    if (valid) {
                        this.postFunc("/erp/user.create",this.userForm,response=>{
                            if(response.data.code==0){
                                this.getList();
                                this.userDialogVisible = false;
                                this.tip('新增成功','success');
                                //this.$emit('updateAdminList');
                            }
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    } else {
                        return false;
                    }
                });
            }else{
                this.$refs[ruleForm].validate((valid) => {
                    if (valid) {
                        var params = {};
                        params.name = this.userForm.name;
                        params.id = this.userID;
                        params.combination = this.userForm.combination;
                        params.occupation = this.userForm.occupation;
                        params.mobile = this.userForm.mobile;
                        params.password = this.userForm.password;
                        this.postFunc("/erp/user.update",params,response=>{
                            if(response.data.code==0){
                                this.getList();
                                this.userDialogVisible = false;
                                this.tip('修改成功','success');
                            }
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    } else {
                        return false;
                    }
                })
            }
        },
        //初始化密码
        // initialize(){
        //     const self = this;
        //     this.$confirm('原密码将失效, 是否继续?', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         this.postFunc("/erp/user.reset",{id : self.userID},response=>{
        //             self.$alert('新密码：' + response.data.data.password, '请使用新密码重新登录', {
        //                 showConfirmButton: false,
        //                 // callback: action => {
        //                 //     // self.$logout();
        //                 //     this.$message({
        //                 //         message: '密码初始化成功',
        //                 //         type: 'success'
        //                 //     });
        //                 // }
        //             });
        //         })
        //         // axios.post("/admin.reset",{
        //         //     id : self.userID
        //         // }).then((response) => {
        //         //     if(response.data.code == 0){
                        

        //         //     }
        //         // })
        //     }).catch(() => {

        //     });
        // },
        //新增角色弹窗
        addRole(){
            this.roleDialogVisible = true;
            this.roleText = '新增角色';
            this.isNewOrModifyRole = true;
            this.roleForm = {name: ''};
        },
        //新增角色&修改确定
        submitRole(){
            if(this.isNewOrModifyRole){
                if(this.roleForm.name === ""){
                    this.tip('请输入角色名称','warning')
                    return
                }
                this.postFunc("/erp/role.add",this.roleForm,()=>{
                    this.getRoleList();
                    this.roleDialogVisible = false;
                    this.tip('新增成功', 'success');
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }else{
                this.postFunc("/erp/role.edit",this.roleForm,()=>{
                    this.getRoleList();
                    this.roleDialogVisible = false;
                    this.tip('修改成功','success');
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }
        },
        //修改角色信息
        modifyRole(row){
            this.roleDialogVisible = true;
            this.isNewOrModifyRole = false;
            this.roleText = '修改角色信息';
            this.roleForm = JSON.parse(JSON.stringify(row));
            this.roleID = row.id;
        },
        //删除角色
        deleteRole(row){
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postFunc("/erp/role.delete",{id: row.id},()=>{
                    this.getRoleList();
                    this.tip('删除成功','success');
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(() => {
            });
        },
        //分页
        getPage(obj){
            this.current_page=obj.currentpage;
            this.params.per_page=obj.pagesize;
            this.params.page = obj.currentpage;
            this.getList();
        },

        //新增角色管理
        authorityEdit(t,id){
            localStorage.removeItem("dw_setting_auth_"+t+"_id");
            localStorage.setItem("dw_setting_auth_"+t+"_id",id);
            var obj=new Object();
            obj.label="权限管理";
            obj.name="权限管理"+t+id;
            obj.content="settingUserAuth";
            this.$emit("clickAdd",obj)
        },

        cancelEdit(formName){
            this.$refs[formName].resetFields();
        }

    },
    watch:{
        // "params.page":function(value){
        // 	this.getList();
        // },
        userDialogVisible(value){
            if (!value) {
                this.$refs.ruleForm.clearValidate();
            }
        },
        setWarehouseDialog:function(val){
            if(!val){
                this.setWarehouse = [];
                this.setWarehouseName = [];
                this.warehouseConfirm = {id:"",warehouse_ids:[],sales_warehouse_ids:[]}
            }
        }
    }

}
</script>
